import { render, staticRenderFns } from "./BoardMemberUserAdminSUP.vue?vue&type=template&id=3c1555a5&scoped=true"
import script from "./BoardMemberUserAdminSUP.vue?vue&type=script&lang=js"
export * from "./BoardMemberUserAdminSUP.vue?vue&type=script&lang=js"
import style0 from "./BoardMemberUserAdminSUP.vue?vue&type=style&index=0&id=3c1555a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1555a5",
  null
  
)

export default component.exports